import { ICartEngraving } from '~domain/entities/CartItem/ICartItem';
import { IPGKitItems } from '~api/KitsAPI/utils/IKits';

const emptyEngravingItem = {
    UNIT_PRICE: 0,
    DISCOUNT_AMOUNT: 0,
    DISCOUNT_PCT: null,
    discountPercent: null,
    DISCOUNT_PRICE: null
};

export const engravingMapper = (item: IPGKitItems): ICartEngraving => {
    const { engraving } = item;
    const engravedSkuId = engraving?.engraved_sku_id || '';
    const engravingItem =
        item.items.find((kitItem) => kitItem['sku.SKU_BASE_ID'] !== engravedSkuId) ||
        emptyEngravingItem;
    const engravingType = engraving?.engraving_type || '';

    return {
        engravedSkuId,
        engravingType: engravingType,
        price: engravingItem?.UNIT_PRICE,
        message: engraving?.message || [],
        selectedFont: item?.MONOGRAM_FONT || '',
        templateId: item.engraving?.templateId || 0,
        templatesArray: item.engraving?.templates || {},
        discountPercent: engravingItem?.DISCOUNT_PCT || engravingItem?.discountPercent || 0,
        discountedUnitPriceWithTax:
            engravingItem?.DISCOUNT_PRICE ||
            engravingItem?.UNIT_PRICE + engravingItem?.DISCOUNT_AMOUNT
    };
};
